import { render, staticRenderFns } from "./LandingCreatorsWhyJoin.vue?vue&type=template&id=de2c2a66&scoped=true&"
import script from "./LandingCreatorsWhyJoin.vue?vue&type=script&lang=ts&"
export * from "./LandingCreatorsWhyJoin.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCreatorsWhyJoin.vue?vue&type=style&index=0&id=de2c2a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2c2a66",
  null
  
)

export default component.exports